/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagefiltercheckin4Inputs */

const en_ticketpagefiltercheckin4 = /** @type {(inputs: Ticketpagefiltercheckin4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry`)
};

const de_ticketpagefiltercheckin4 = /** @type {(inputs: Ticketpagefiltercheckin4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einlass`)
};

/**
* | output |
* | --- |
* | "Entry" |
*
* @param {Ticketpagefiltercheckin4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagefiltercheckin4 = /** @type {((inputs?: Ticketpagefiltercheckin4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagefiltercheckin4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagefiltercheckin4(inputs)
	return de_ticketpagefiltercheckin4(inputs)
});
export { ticketpagefiltercheckin4 as "ticketPageFilterCheckIn" }